const BLOG_LOADING = "BLOG_LOADING";
const BLOG_ERROR = "BLOG_ERROR";
const BLOG_SUCCESS = "BLOG_SUCCESS";

export { BLOG_ERROR, BLOG_SUCCESS, BLOG_LOADING };
